export * from './Articulo.nav';